/* esm.sh - @noble/curves@2.0.1/abstract/modular */
export * from "/*@noble/curves@2.0.1/esnext/abstract/modular.mjs";
